import React from 'react';
import {
  isPhraseSegment,
  isTextSegment,
  parseSmartPhrases,
  getSmartKeyTextSyntax,
  type SmartPhraseContext,
} from '@rsos/utils/SmartPhrases';
import SmartPhraseChip from '../SmartPhraseChip/SmartPhraseChip';

interface SmartPhraseTextProps {
  text: string;
  context?: SmartPhraseContext;
  variant?: 'default' | 'admin';
}

const SmartPhraseText = ({
  text,
  context,
  variant = 'default',
}: SmartPhraseTextProps) => {
  const segments = parseSmartPhrases(text);

  return (
    <span>
      {segments.map((segment, i) => {
        if (isTextSegment(segment)) {
          // Plain text between smart phrases — no decoration needed.
          return (
            <React.Fragment key={`text-${i}`}>{segment.content}</React.Fragment>
          );
        }

        if (!isPhraseSegment(segment) || !segment.phrase) {
          // Unrecognised placeholder — render it raw so the author can see it
          // wasn't resolved rather than silently swallowing the syntax.
          return (
            <React.Fragment key={`phrase-${i}`}>
              {getSmartKeyTextSyntax(segment.key)}
            </React.Fragment>
          );
        }

        const { phrase } = segment;

        // Known smart phrase — render as a highlighted badge. The tooltip
        // shows the description so operators understand what the value represents.
        return (
          <SmartPhraseChip
            key={phrase.key}
            phrase={phrase}
            context={context}
            variant={variant}
          />
        );
      })}
    </span>
  );
};

export default SmartPhraseText;
